import styled from 'styled-components';
import {PillButton} from "../../../../../../CommonComponents/commonStyles";

export const SelectComponentWrap = styled.div`
    .ant-form-item-control {
        line-height: unset;
    }
`

export const PillButtonGreen = styled(PillButton)`
    background-color: #006778;
    color: #ffffff;
    font-family: HelveticaNeue-Medium;
    font-size: 14px;
    &:hover, &:focus {
    color: #ffffff;
    border-color: #d4d4d4;
    background-color: #006778;
}
`

export const PillButtonGreenWrap = styled.div`
    button {
        height: 30px !important;
    }
    margin:  ${props => props.marginBottom ? '34px 0px 50px 0px' :  '34px 0 20px 0' };

`

export const PillButtonAddSpace = styled.div`
    margin-top: 16px;
    margin-bottom: 50px;
`

export const PillButtonAddSpaceAdd = styled(PillButtonAddSpace)`
    margin-bottom: 30px;
    margin-top: 0;
`

export const PillButtonAddSpaceAddManual = styled(PillButtonAddSpace)`
    margin-bottom: 18px;
    margin-top: 0;
    display:flex;
    justify-content:flex-start;
`

export const TabsWrapper = styled.div`
    .ant-tabs-tab {
        margin: 0 !important;
        height: 55px !important;
        border-radius: 0 !important;
        background: #ffffff !important;
        border-top: 4px solid rgba(0,103,120,0.1) !important;
        border-bottom: 1px solid #d4d4d4 !important;
    }
    .ant-tabs-nav-animated {
            line-height: 65px;
        }

    .ant-tabs-nav-container {
        
        height: 55px !important;
    }

    .ant-tabs-bar {
        border-bottom: 1px solid #d4d4d4;
    }
    .ant-tabs-tab-active {
        border-color: #d4d4d4 !important;
        border-top: 4px solid #006778 !important;
        border-bottom: none !important;
    }
    .ant-tabs-ink-bar {
        height: 1px;
        background-color: #d4d4d4;
    }

    .ant-tabs-tab-prev, .ant-tabs-tab-next {
        display: block;
    }
    .ant-tabs-tab-btn-disabled {
        cursor: pointer;
    }

    .ant-tabs-tab-prev {
        left: -10px;
    }

    .ant-tabs-tab-next {
        right: -10px;
    }
    
`

export const TitleWrap = styled.div`
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    letter-spacing: 0.5px;
    color: ${props => props.theme.fontColors.primary};
    padding: 8px 4px 4px 4px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.secondary};
    }
`